import m from "../../geodata/es2015/saoTomePrincipeHigh";
window.am4geodata_saoTomePrincipeHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/saoTomePrincipeHigh.js
// module id = null
// module chunks = 